// @flow
import React, { Component, createRef } from 'react';
import classnames from 'classnames/bind';
import styles from './styles.scss';
import Button from 'Components/Button';
import FocusedImage from 'Components/FocusedImage';
import AssetModel from 'Stores/AssetModel';
import { isExternalLink } from 'Utils';
import { Link } from 'react-router-dom';
import { cardTracking } from 'Utils/trackingAttributes';
import ConsumptionData from 'Components/ConsumptionData';
import { lowerCase6e } from 'Utils/special/lowerCaseSpecial';

const cx = classnames.bind(styles);

export type CardProps = {
  link: string,
  title: string,
  image: string,
};

export default class Card extends Component<CardProps> {
  constructor(props) {
    super(props);

    const imageSrc =
      (props.image && props.image.thumbnails && props.image.thumbnails['600x600']) ||
      (props.image && props.image.src);
    this.asset = createRef();
    this.asset.current = new AssetModel({ ...props, src: imageSrc });

    this.state = {
      showConsumption: false,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      if (!this.state.showConsumption) {
        this.setState({ showConsumption: true });
      }
    }, 2000);
  }

  render() {
    const { link: href, title, consumptionText } = this.props;
    const { showConsumption } = this.state;
    const isExternal = isExternalLink(href);

    return (
      <div className={cx('card')}>
        <div className={cx('card-image')}>
          {consumptionText && (
            <ConsumptionData
              actionIcon={showConsumption ? 'close' : 'eco'}
              onClick={() =>
                this.setState((old) => ({
                  showConsumption: !old.showConsumption,
                }))
              }
              consumptionText={[consumptionText]}
              inside="tile"
              style={{
                opacity: +showConsumption,
              }}
              hideCloseButton={true}
            />
          )}

          <FocusedImage image={this.asset.current} useThumb={false} />
        </div>

        {href && isExternal && (
          <a
            style={{ height: '100%', width: '100%' }}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            {...cardTracking('mehr erfahren', title)}
          >
            <div className={cx('card-action-wrapper')}>
              <h3
                className={cx('card-title')}
                dangerouslySetInnerHTML={{ __html: lowerCase6e(title) }}
              />

              <Button
                type="secondary"
                href={undefined}
                light
                label="Mehr erfahren"
                additionalProps={cardTracking('mehr erfahren', title)}
              />
            </div>
          </a>
        )}

        {href && !isExternal && (
          <Link
            style={{ height: '100%', width: '100%' }}
            to={href}
            onClick={this.linkClick}
            {...cardTracking('mehr erfahren', title)}
          >
            <div className={cx('card-action-wrapper')}>
              <h3
                className={cx('card-title')}
                dangerouslySetInnerHTML={{ __html: lowerCase6e(title) }}
              />

              <Button
                type="secondary"
                href={undefined}
                light
                label="Mehr erfahren"
                additionalProps={cardTracking('mehr erfahren', title)}
              />
            </div>
          </Link>
        )}
      </div>
    );
  }
}
